module.exports = __webpack_public_path__ + "static/media/quote.90c6b2da.png";